import { render, staticRenderFns } from "./BatchJobProgressBar.vue?vue&type=template&id=f2bf4108&"
import script from "./BatchJobProgressBar.vue?vue&type=script&lang=js&"
export * from "./BatchJobProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports